import React, {
    lazy,
    Suspense,
    Fragment
} from 'react';
import {
    Switch,
    Route
} from 'react-router-dom'


import LoadingBackground from '../components/CircularLoader';
import ThemeContext from '../contexts/ThemeContext';
import { TagManagerProvider } from '../contexts/TagManagerContext';



const routesConfig = [
    {
        exact: true,
        path: '/',
        component: lazy(() => import('../views/homepage/'))
    },
    {
        exact: true,
        path: '/result/:requestType/:traceCode/:country?/:token?',
        component: lazy(() => import('../views/result'))
    },
    {
        exact: true,
        path: '/redirect/:requestType/:traceCode/:productInfo?',
        component: lazy(() => import('../views/redirection/index'))
    },
    {
        exact: true,
        path: '*',
        component: lazy(() => import('../components/404'))
    },
]


const renderRoutes = (routes) => (routes ? (
    <Suspense fallback={<LoadingBackground />}>
        <Switch>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;

                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => (
                            <TagManagerProvider>
                                <ThemeContext.Consumer>
                                    {(context) => (
                                        <Guard>
                                            <Layout>
                                                {route.routes
                                                    ? renderRoutes(route.routes)
                                                    : <Component themeConfig={context.selectedTheme} {...props} />}
                                            </Layout>
                                        </Guard>
                                    )}
                                </ThemeContext.Consumer>
                            </TagManagerProvider>

                        )}
                    />
                );
            })}
        </Switch>
    </Suspense >
) : null);

function Routes() {
    return renderRoutes(routesConfig);
}

export default Routes;